export default "__VITE_ASSET__CFu9m0JN__"